document.addEventListener('DOMContentLoaded', () => {
  updateAccordionState();
  updateAccordionsStyles();
})

window.addEventListener('hashchange', function () {
  updateAccordionState();
});

let updateAccordionState = () => {
  let hash = window.location.hash;
  
  if (hash) {
    let el = document.querySelector( hash + ' > details')

    el.setAttribute('open', '');
  }
}

// let updateAccordionsStyles = () => {
//   let items = document.querySelectorAll(`.ndow-accordion`);
  
//   items.forEach(el => {
//     let color = el.getAttribute('data-bg');
    
//     el.style.setProperty('--color', color);
//   });
// }